<div class="mat-margin-top mat-justify-content-center mat-align-items-center">
	<mat-form-field>
		<mat-label>Enter a date range</mat-label>
		<mat-date-range-input [rangePicker]="picker">
		  <input matStartDate [formControl]="startDate" placeholder="Start date">
		  <input matEndDate [formControl]="endDate" placeholder="End date">
		</mat-date-range-input>
		<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
		<mat-date-range-picker #picker></mat-date-range-picker>
	  </mat-form-field>
</div>
<div class="mat-margin-top mat-justify-content-center mat-align-items-center">
	<button mat-raised-button class="generateButton cancelBtn" expand="block" (click)="cancel()">Cancel</button>
	@if (!downloading) {
	<button mat-raised-button class="primary-btn generateButton" expand="block" (click)="exportReport()">
		Generate
	</button>
	}
	@if (downloading) {
	<mat-spinner class="downloadSpinner"></mat-spinner>
	}
</div>